import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CardModule } from 'primeng/card';
import { ContractService } from './services/contract.service';

@Component({
  selector: 'app-contract',
  standalone: true,
  imports: [CardModule, RouterOutlet],
  templateUrl: './contract.component.html',
  styleUrl: './contract.component.css'
})
export class ContractComponent {
  service = inject(ContractService)

  ngOnInit(): void {
    this.service.title.update((value) => 'Contratos')
  }
}
